/**
 * TODO Replace the API invocation in this file with a generated API client version
 * when a proper API for org info is available.
 */

import auth0MetadataMappingResponse from '@auth/stubs/getAuth0MetadataMapping.json';
import { User } from '@auth0/auth0-react';
import { utcToZonedTime } from 'date-fns-tz';
import { z } from 'zod';

const isTimeZone = (tz: string) => {
  const d = utcToZonedTime(new Date(), tz);
  return !Number.isNaN(d.getTime());
};

const auth0MetadataSchema = z.object({
  defaultTimeZone: z
    .string()
    .min(9)
    .max(30)
    .refine(isTimeZone, (val) => ({ message: `${val} is not a valid timezone.` })), // e.g. Europe/London.
  locale: z.enum(['en-GB', 'en-US']),
  routes: z.enum([
    'boost',
    'boostReportArchiveOnly',
    'generativeCopy',
    'boostAndGenerativeCopy',
    'priceArtefactsOnly',
    'priceDynamicSeasonOnly',
    'priceDynamic',
    'all',
  ]),
  url: z.string().min(2), // Organisation-specific subpath e.g. ocula.tech/eu/{url}/boost.
});

type Auth0Metadata = z.infer<typeof auth0MetadataSchema>;

type OrgRoutes = readonly {
  /** The route path  */
  route: string;
  /** Display as disabled in side navigation  */
  disabled?: boolean;
}[];

type OrgMetadataRoutes = Omit<Auth0Metadata, 'routes'> & { routes: OrgRoutes };

export type OrganisationsMetadataRoutes = readonly OrgMetadataRoutes[];

export function getOrgMetadataRoutes(
  user: User,
):
  | { data: OrganisationsMetadataRoutes; kind: 'success' }
  | { error: { message: string; details?: unknown }; kind: 'error' } {
  try {
    const metadata = auth0MetadataSchema.parse(user?.['https://ocula.tech/actions/organizations']?.metadata);
    return {
      data: [
        {
          ...metadata,
          routes: auth0MetadataMappingResponse.metadata.routes?.[metadata?.routes],
        },
      ],
      kind: 'success',
    };
  } catch (error) {
    const details = error && typeof error === 'object' && 'issues' in error && error?.issues;
    return {
      error: {
        message: 'User session metadata validation error',
        details,
      },
      kind: 'error',
    };
  }
}
